module.exports = __webpack_public_path__ + "img/selected1-min.6df6966f.png";